import { useQuery } from '@tanstack/react-query'

import { getEnrollmentAdministrationProcedures } from '../../../api/enrollments/get-enrollment-adminstration-procedure'
import { ItemNotFound } from '../../../components/elements/item-not-found'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import useEnrollment from '../../../lib/hooks/use-enrollment'

export default function ClientAdminstrationProcedures() {
  const { enrollment } = useEnrollment()

  const { data, isPending, error } = useQuery({
    queryKey: ['adminstration-procedures', enrollment?.id],
    queryFn: () => getEnrollmentAdministrationProcedures(enrollment.id),
    enabled: !!enrollment?.id
  })

  if (error) return <ItemNotFound title="Aucune page trouvée" />
  if (isPending) return <LoadingScreen />

  return <div dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
}
